<template>
  <v-container class="px-3">
    <v-row class="mx-1">
      <v-col class="pb-1 pt-0" cols="12">
        <h1>Complemento de cronograma (Lote)</h1>
        <p>Acrescente os lotes complementares para que sejam conciliados no módulo de recebíveis.</p>
      </v-col>
      <v-col class="py-1" cols="12">
        <CronogramaFilter
          v-show="showList"
          :filter="filter"
          :prestadores="prestadores"
          :operadoras="listOperadora"
          :responsaveis="listResponsavel"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :getOperadoras="(item) => getOperadoras(item)"
          :getResponsaveis="(item) => getResponsaveis(item)"
          :controlResponsavel="controlResponsavel"
          :userData="userData"
          :updateFilter="(flt, page, clear) => getList(flt, page, clear)"
          :prestadorId="(id) => prestadorId = id"
          :isComplementar="true"
        />
      </v-col>
      <v-col class="py-1" cols="12">
        <CronogramasList
          v-show="showList"
          :cronogramas="listCrono"
          :listLotes="listLotes"
          :paginationCrono="paginationCrono"
          :paginationLotes="paginationLotes"
          :parameters="parameters"
          :filterData="filter"
          :updateFilter="(filterData, page) => getList(filterData, page)"
          :getListLotes="(item, page, crono) => getListLotes(item, page, crono)"
          :deleteCronogramaConfirm="(crono) => deleteCronogramaConfirm(crono)"
          :deleteLoteConfirm="(lotes, crono) => deleteLoteConfirm(lotes, crono)"
          :concluirCronograma="(grupo)=> concluirCronogramaConfirm(grupo)"
          :showOpen="
            (selectedLotes, grupoSelecionado) =>
              showOpen(selectedLotes, grupoSelecionado)
          "
          :userData="userData"
        />
      </v-col>
      <ModalAssociarCronograma
        :vl_total="vl_total"
        :tableInfo="showTable"
        :listCrono="listCrono"
        :selectedGrupo="selectedGrupo"
        :selectedLotes="selectedLotes"
        :responsaveis="listResponsavel"
        :showClose="(val) => showClose(val)"
        :associarLoteCronoExistente="(item) => associarLoteCronoExistente(item)"
        :saveCronoEAssociaLote="(item) => confirmAcao(item)"
        :length="length"
      />
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CronogramaFilter from "@/components/recebiveis/lotes_pendentes/CronogramaFilter";
import CronogramasList from "@/components/recebiveis/lotes_pendentes/CronogramasList";
import ModalAssociarCronograma from "./lotes_pendentes/ModalAssociarCronograma";
export default {
  components: {
    CronogramaFilter,
    CronogramasList,
    ModalAssociarCronograma,
  },
  data() {
    return {
      parameters: null,
      filter:null,
      listCrono:[],
      prestadorId: null,
      controlResponsavel: true,
      selectedGrupo: {},
      selectedLotes: [],
      showTable: false,
      showList: true,
      listGrupos: [],
      listLotes: [],
      pagination: {
        limit: 20,
        offset: 1,
        current_page: 1,
      },
      paginationCrono:{
        limit: 20,
        offset: 1,
        current_page: 1,
      },
      paginationLotes:{
        limit: 20,
        offset: 1,
        current_page: 1,
      },
      prestadores: [],
      searchLote: "",
      vl_total: 0,
      length: null,
    };
  },
  computed: {
    ...mapState({
      // filter: (state) => state.recebiveis.filter,
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      grupoEconomicoList: state =>state.permissions.grupoEconomicoList,
      listCronoLength: (state) => state.faturamento.listCronoLength,
      listOperadora: (state) => state.faturamento.listOperadora,
      listResponsavel: (state) => state.recebiveis.listResponsavel,
      userData: (state) => state.userData.userData,
    }),
  },
  mounted() {
    this.prestadores = this.$store.getters[
      "permissions/getPrestadoresByGeco"
    ]();
    let userData = this.$store.state.userData.userData
    this.controlResponsavel = !userData.Permissao.faturamento.includes('gestor')
    let opts = {
      grupoEconomico: this.grupoEconomico,
      modulo_operadora: "recebiveis",
      prestador_ids: []
    };
    this.getOperadoras(opts);
    this.getResponsaveis(opts);
  },
  methods: {
    ...mapActions("recebiveis", ["getResponsaveis"]),
    ...mapActions("faturamento", ["getCronogramas", "getDetalhesCronograma"]),
    ...mapActions("permissions", ["getOperadoras"]),
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if(!year || !month || !day){
        return null
      }
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      if(!year || !month || !day){
        return null
      }
      return `${year}-${month}-${day}`;
    },
    async getList(filter, page, clear) {
      filter = filter? filter : this.filter
      await this.saveFilter(filter)
      if(clear) {
        this.listCrono = []
        this.paginationCrono.total_pages = 0
        this.paginationCrono.offset = 1
        this.paginationCrono.current_page = 1
        return
      }
      this.paginationCrono.offset = page? page : 1
      let payload = Object.assign(this.paginationCrono, {grupo_economico: this.grupoEconomico}, filter)
      let obj = {query:[ {modulo: 'Faturamento', acao: 'getcronogramascomplementares', payload: payload}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then(response => {
        let { total_pages, current_page, dados } = response
        this.listCrono = dados
        this.paginationCrono.total_pages = total_pages
        this.paginationCrono.offset = current_page
        this.paginationCrono.current_page = current_page
      })
    },
    showClose(val) {
      this.showTable = val;
      this.listCrono = [];
      this.selectedGrupo = {};
    },
    
    getListLotes(formData, page, crono) {
      console.log('getListLotes',crono)
      let opts = {
            query: [
                {
                Modulo: "Portal",
                Acao: "getparametrizacoes",
                Payload: {
                    grupo_economico: this.grupoEconomico,
                    operadora_ans_id: crono.operadora_ans_id,
                    prestador_id: crono.prestador_id
                },
                },
            ],
            noLoader: true,
            };
      this.$store.dispatch("request/doRequest",opts, {root: true}).then(config => {
      this.parameters = config.parametros;
      this.lotesList = [] // Limpa os lotes para não abrir com lotes de outro cronograma.
      this.showLotes = true
      this.showUpload = false
      let grupo_economico = this.grupoEconomico
      let cronograma_id = formData.cronograma_id
      let payload ={ grupo_economico, cronograma_id }
      let obj = {query:[ {acao: 'getlotescomplementares', modulo: 'Faturamento', payload: payload}]}
      this.$store.dispatch("request/doRequest",obj, {root: true}).then(response => {
        let { dados, total_pages, current_page } = response;
        this.listLotes = dados;
        this.paginationLotes.total_pages = total_pages;
        this.paginationLotes.offset = current_page;
        this.paginationLotes.current_page = current_page;
        this.showList = true;
        let indexCrono = this.listCrono.findIndex(crono => crono.id == cronograma_id)
        if(indexCrono){
          this.listCrono[indexCrono].qt_arq_novo = dados.filter(el => el.is_deleted).length
          this.$nextTick()
        }
        })
      })
    },
    deleteLoteConfirm(lotesList, crono) {
      let paramModal = {};
      let prestador_id = crono.prestador_id;
      let crono_id = crono.id;
      let lotes = lotesList.reduce((arr, item) => {
        let id = item.id;
        let dt_alteracao = item.dt_alteracao;
        if (item) {
          arr.push({ id, dt_alteracao });
        }
        return arr;
      }, []);
      let temLotesEmValidacao =  lotesList.filter(el => el.etapa <= 10).length > 0;
      let temLotesJaIntegrados= lotesList.filter(el => el.is_deleted == false).length > 0;
      let temLotesValidados = lotesList.filter(el => el.etapa >= 20 && el.proc_trd_tem_erro == 0).length > 0;
      if (temLotesEmValidacao || temLotesJaIntegrados) {
        let mensagens=[]
        if(temLotesEmValidacao) { mensagens.push("Lotes em Validação não podem ser excluídos. Desmarque-os.")}
        if(temLotesJaIntegrados) { mensagens.push("Lotes já incorporados ao cronograma não podem ser excluidos.<br> Desmarque os lotes sem o icone de <b>novo</b>.")}
        paramModal = {
          type: "warning",
          title: "Atenção!",
          message: mensagens.join('<br>'),
          callback: null,
          btConfirm: { name: "Ok", show: true },
          textForm: { show: false },
        };
      } else if (temLotesValidados) {
          paramModal = {
            type: "error",
            title: "ATENÇÃO",
            message:
              "Existem lotes já validados.<br>Ao excluir, os lotes selecionados não estarão mais disponíveis.<br><b>Essa alteração não poderá ser desfeita.</b>",
            callback: null,
            messageForm: (justificativa) => {
              this.deleteLote(
                {
                  grupo_economico: this.grupoEconomico,
                  prestador_id,
                  justificativa,
                  is_justificavel: 1,
                  lotes,
                },
                crono_id,
                crono
              );
            },
            btConfirm: { name: "Excluir", show: true, color: "error" },
            btCancel: { name: "Não", show: true },
            textForm: {
              label: "Por que você está excluindo esse(s) lote(s)?",
              show: true,
            },
          };
      } else {
        paramModal = {
          type: "error",
          title: "ATENÇÂO",
          message:
            "Ao excluir, estes lotes selecionados não estarão mais disponíveis.<br><b>Essa alteração não poderá ser desfeita.</b>",
          callback: () => {
            this.deleteLote(
              {
                grupo_economico: this.grupoEconomico,
                prestador_id,
                is_justificavel: 0,
                lotes,
              },
              crono_id,
              crono
            );
          },
          messageForm: null,
          btConfirm: { name: "Excluir", show: true, color: "error" },
          btCancel: { name: "Não", show: true },
          textForm: {
            label: "",
            show: false,
          },
        };
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    // OK DELETE
    deleteLote(payload, crono_id, crono) {
      let obj = {
        query: [
          {
            Modulo: "faturamento",
            Acao: "deletelote",
            Payload: payload,
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.erros.length) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso",
          message: response.mensagem,
          callback: () => {
            this.getListLotes({ cronograma_id: crono_id }, 1, crono);
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { show: false },
          textForm: { show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },

    deleteCronogramaConfirm(crono) {
      let obj = {
        query: [
          {
            Modulo: "faturamento",
            Acao: "deletecronograma",
            Payload: {
              grupo_economico: this.grupoEconomico,
              id: crono.id,
              dt_alteracao: crono.dt_alteracao
            },
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.erros.length) {
          this.$store.commit("hideLoader")
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso",
          message: response.mensagem,
          callback: ()=> {this.getList(this.filter, 1)},
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: "Não", show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },

    concluirCronogramaConfirm(crono) {
      let paramModal = {}
        let opts = {grupo_economico: this.grupoEconomico, ...crono}
        paramModal = {
          type: "warning",
          title: "Concluir cronograma?",
          message: 'Verifique se incluiu todos os lotes complementares. <br> Após a conclusão não poderão mais ser adicionados lotes complementares.',
          callback: () => this.concluirCronograma(opts),
          btConfirm: { name: "Sim", show: true, color: "warning"},
          btCancel: { name: "Não", show: true }
        }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal)
    },
    concluirCronograma(opts) {
      let obj = {
        query: [
          {
            Modulo: "Faturamento",
            Acao: "closecronogramacomplementar",
            Payload: {...opts},
          },
        ],
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getList(this.filter, this.paginationCrono.offset)
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });

    },

    // OK ASSOCIAR
    associarLoteCronoExistente(item) {
      const {
        cronograma_id,
        remessa_id,
        upload_user_id,
        prestador_id,
        lotes,
      } = item;

      let obj = {
        query: [
          {
            Modulo: "faturamento",
            Acao: "associarlotesemcronograma",
            Payload: {
              grupo_economico: this.grupoEconomico,
              cronograma_id,
              upload_user_id,
              lotes,
              prestador_id,
              remessa_id,
            },
          },
        ],
      };

      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || response.error) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem ?? "Associação efetuada com sucesso",
          callback: () => {
            this.saveCallback({ prestador_id: item.prestador_id });
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },

    confirmAcao(item) {
      if (!item.owner_id) {
        this.saveCallback(item.prestador_id);
        return;
      }
      let paramModal = {
        type: "info",
        title: "Confirmar ação",
        message: "Você poderá editar novamente quando necessário",
        callback: () => this.saveCronoEAssociaLote(item),
        btConfirm: { name: "Salvar", show: true },
        btCancel: { name: "Cancelar", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },

    saveCallback(val) {
      this.getListGrupos(val);
      this.showTable = false;
    },

    // OK ADD CRONOGRAMA
    saveCronoEAssociaLote(item) {
      let payload = item;
      let data = {
        query: [
          {
            Modulo: "faturamento",
            Acao: "addcronograma",
            Payload: payload,
          },
        ],
      };
      this.$store.dispatch("request/doRequest", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let [cronograma_id] = response.ids;
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.associarLoteCronoExistente({ cronograma_id, ...item });
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { show: false },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      });
    },
    saveFilter(filter){
      this.filter = filter
      let opts = {
          filterData: {
            grupo_economico: this.grupoEconomico,
            ...filter
          },
          filterName: 'lotesPendentes',
          redirect: false
        }
        this.$store.commit('recebiveis/setFilter', opts, { root:true })
    },
  },
};
</script>